export default __webpack_public_path__ + "static/media/ai_icon.2b817a0f.svg";